<template>
	<div class="order">
		<van-sticky>
			<div class="rcst_sc">
				<div @click="backPrev()" class="rcst_sc_drop">
					<div class="rcst_sc_drop_left">
						<img src="../demo1/source/back.png" alt="" />
					</div>
				</div>
				<div class="rcst_sc_drop_center">我的订单</div>
			</div>
		</van-sticky>

		<div v-if="is_load">
			<div v-if="venus_list.length>0">
				<van-list v-model="loading" :finished="finished" :offset="10" finished-text="没有更多了"
					@load="onLoadNextPage">
					<div class="order_body">
						<div v-for="(item,index) in venus_list" :key="index" class="order_body_item">
							<div class="order_body_item_title">
								{{item.class_name}}
								<div :class="[{'order_body_item_tagS':item.status==1},'order_body_item_tag']">
									{{item.status==0?'待确认':item.status==1?'待使用':item.status==2?'已完成':item.status==3?'已取消':''}}
								</div>
							</div>
							<div class="order_body_block order_body_block_mag30">
								预约酒店
								<div>{{item.venue_name}}</div>
							</div>
							<div class="order_body_block order_body_block_mag20">
								预约日期
								<div>{{item.book_time}}</div>
							</div>
							<div class="order_body_block order_body_block_mag20">
								预约人
								<div>{{item.book_name}} {{item.book_mobile}}</div>
							</div>
							<div class="order_body_block order_body_block_mag20">
								中行兑换码
								<div>{{item.code}}</div>
							</div>
							<div v-if="item.status==1" class="order_body_verify order_body_block_mag30">
								<div class="order_body_verify_1">核销码</div>
								<div class="order_body_verify_2 order_body_block_mag20">{{item.verify_codeM}}</div>
								<div @click="cancelOrder(item)" class="order_body_verify_3 order_body_block_mag30">申请退订
								</div>
							</div>
						</div>
					</div>
				</van-list>
			</div>
			<div v-else>
				<empty />
			</div>
		</div>


	</div>
</template>

<script>
	import empty from '../../components/empty.vue';
	import {
		expEasyNumber
	} from "../../lib/utils.js"
	export default {
		components: {
			empty
		},
		data() {
			return {
				is_load: false,

				page: 1,
				page_size: 20,
				venus_list: [], //列表

				loading: true, //是否处于加载状态，加载过程中不触发load事件
				finished: false, //是否已加载完成，加载完成后不再触发load事件
			}
		},
		mounted() {
			this.getOrderListBefore()
		},
		methods: {
			backPrev() {
				this.$router.go(-1)
			},
			// 获取订单列表
			getOrderListBefore() {
				this.$loading('正在加载中...');
				this.is_load = false
				this.page = 1
				this.venus_list = []
				this.loading = true
				this.finished = false
				this.getOrderList()
			},
			getOrderList() {
				var $this = this
				var param = {
					page: this.page,
					page_size: this.page_size
				}
				var qs = require('qs');
				let url = this.api.userApi.demo1_bookingList
				this.axios.post(url, qs.stringify(param))
					.then((res) => {
						var venus_list = res.data.items
						venus_list.map((item) => {
							item.verify_codeM = expEasyNumber(item.verify_code)
						})
						if ($this.page == 1) {
							$this.venus_list = venus_list
							$this.loading = false
							$this.finished = venus_list.length < $this.page_size ? true : false
							$this.is_load = true
						} else {
							$this.venus_list = [...$this.venus_list, ...venus_list]
							$this.loading = false
							$this.finished = venus_list.length < $this.page_size ? true : false
							$this.is_load = true
						}
						$this.$loading.close();
					}).catch((error) => {
						$this.$toast(error.msg ? error.msg : error.message);
						$this.$loading.close();
					})
			},
			// 加载下一页
			onLoadNextPage() {
				this.$loading('正在加载中...');
				this.loading = true
				this.page = this.page + 1
				this.getOrderList()
			},
			// 取消订单
			cancelOrder(e) {
				var $this = this
				this.$dialog.confirm({
						title: '温馨提示',
						message: '是否取消订单？',
						confirmButtonColor: '#F77F28',
						confirmButtonText: '取消订单',
						cancelButtonColor: '#999999',
						cancelButtonText: '暂不取消',
					})
					.then(() => {
						// on confirm
						$this.$loading('正在取消...');
						$this.cancelOrderConfirm(e.order_no)
					})
					.catch(() => {
						// on cancel
					});
			},
			cancelOrderConfirm(e) {
				var $this = this
				var param = {
					order_no: e
				}
				var qs = require('qs');
				let url = this.api.userApi.demo1_cancel
				this.axios.post(url, qs.stringify(param))
					.then((res) => {
						$this.$loading.close();
						$this.getOrderListBefore()
					}).catch((error) => {
						$this.$toast(error.msg ? error.msg : error.message);
						$this.$loading.close();
					})
			}
		}
	}
</script>

<style lang="less" scoped="scoped">
	@vm_base: 1/750*100vw;

	.order {
		width: 100%;
		padding-bottom: calc(constant(safe-area-inset-bottom) / 2 + 20*@vm_base);
		padding-bottom: calc(env(safe-area-inset-bottom) / 2 + 20*@vm_base);
	}

	.rcst_sc {
		width: 100%;
		/* padding: 0 30*@vm_base; */
		padding: 0 30*@vm_base;
		// padding: 0 0 20*@vm_base 0;
		background-color: #fff;

		display: flex;
		justify-content: space-between;
		align-items: center;

		.rcst_sc_drop {
			display: flex;
			justify-content: flex-start;
			align-items: center;
			width: fit-content;

			.rcst_sc_drop_left {
				width: 80*@vm_base;
				height: 80*@vm_base;
				// border: 1*@vm_base solid red;
				display: flex;
				justify-content: flex-start;
				align-items: center;

				img {
					width: 36*@vm_base;
				}
			}
		}

		.rcst_sc_drop_center {
			width: calc(100% - 80*@vm_base);
			height: 80*@vm_base;
			padding-right: 80*@vm_base;
			font-size: 28*@vm_base;
			color: #666666;
			display: flex;
			justify-content: center;
			align-items: center;
		}
	}

	.order_body {
		width: 100%;
		padding: 10*@vm_base 20*@vm_base;

		.order_body_item {
			width: 100%;
			margin-bottom: 20*@vm_base;
			background: #FFFFFF;
			border-radius: 16*@vm_base;
			padding: 0 30*@vm_base 30*@vm_base 30*@vm_base;
		}

		.order_body_item_title {
			width: 100%;
			height: 100*@vm_base;
			display: flex;
			justify-content: space-between;
			align-items: center;
			border-bottom: 1*@vm_base solid #D9D9D9;
			font-size: 30*@vm_base;
			color: #333333;
		}

		.order_body_item_tag {
			font-size: 26*@vm_base;
			color: #999999;
		}

		.order_body_item_tagS {
			color: #F77F28;
		}

		.order_body_block {
			width: 100%;
			display: flex;
			justify-content: space-between;
			align-items: center;
			font-size: 30*@vm_base;
			color: #666666;
			white-space: nowrap;

			div {
				max-width: 100%;
				white-space: nowrap;
				overflow: hidden;
				text-overflow: ellipsis;
				padding-left: 20*@vm_base;
			}
		}

		.order_body_verify {
			width: 100%;
			border-top: 1*@vm_base solid #D9D9D9;
			padding-top: 30*@vm_base;

			.order_body_verify_1 {
				font-size: 30*@vm_base;
				color: #666666;
			}

			.order_body_verify_2 {
				width: 100%;
				font-size: 40*@vm_base;
				color: #F77F28;
				text-align: center;
				font-weight: bold;
			}

			.order_body_verify_3 {
				width: 180*@vm_base;
				height: 60*@vm_base;
				border-radius: 30*@vm_base;
				border: 1*@vm_base solid #D9D9D9;
				display: flex;
				justify-content: center;
				align-items: center;
				font-size: 28*@vm_base;
				color: #999999;
				margin: 30*@vm_base auto 0 auto;
			}
		}

		.order_body_block_mag30 {
			margin-top: 30*@vm_base;
		}

		.order_body_block_mag20 {
			margin-top: 20*@vm_base
		}
	}
</style>


// WEBPACK FOOTER //
// src/views/demo1/order.vue